module.exports = __webpack_public_path__ + "img/zhixuelihua-books.cf597963.jpg";